module.exports = __webpack_public_path__ + "static/smoke-6254ae19e965d5ea1f0afdbdd09cdb4c.mp4";